import React, { Component } from 'react';
// import ReactDOM from "react-dom";

import LocationPicker from "react-location-picker";

// import "./styles.css";

const defaultPosition = {
  lat: 27.9878,
  lng: 86.925
};

class MAP extends Component{
  constructor(props) {
    super(props);

    this.state = {
      address: "Kala Pattar Ascent Trail, Khumjung 56000, Nepal",
      position: {
        lat: 24.7253929,
        lng: 46.260624,
      }
    };

    // Bind
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  handleLocationChange({ position, address, places }) {
    // Set new location
    this.setState({ position, address });
    console.log(position);
    console.log(address);
    console.log(places);
  }

  render() {
    return (
      <div>
        {/* <h1>{this.state.address}</h1> */}
        <div>
          <LocationPicker
            containerElement={<div style={{ height: "100%" }} />}
            mapElement={<div style={{ height: "400px" }} />}
            defaultPosition={this.state.position}
            onChange={this.handleLocationChange}
          />
        </div>
      </div>
    );
  }
}

export default MAP
